import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import { IconBaseProps } from 'react-icons';

export function IconSkeleton({ className, size = 20 }: IconBaseProps) {
    return (
        <Skeleton
            variant="rounded"
            className={classNames(className, 'IconSkeleton')}
            width={size}
            height={size}
        />
    );
}
